import Navbar from './Navbar';
import horizontalTab from './../images/horizontalTab.png';

const Header = () => {
  return (
    <header className="header">
      <div className="header-inner">
        <div className="header-top">
          <img
            src={horizontalTab}
            alt="Decorative bar"
            className="header-tab"
          />
        </div>

        <div className="header-main">
          <Navbar />
        </div>
      </div>
    </header>
  );
};

export default Header;